var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"s2",attrs:{"fluid":""}},[_c('v-container',{staticClass:"sinner"},[_c('img',{staticClass:"simg",attrs:{"src":require("@/assets/images/citation.png")}}),_c('p',{staticClass:"pt-8 pb-4"},[_c('i',[_vm._v(_vm._s(_vm.text))]),_vm._v(" - "+_vm._s(_vm.author)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }